import React, { HTMLProps, MouseEventHandler, RefObject, useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { IAppState } from 'src/store';
import { getRandomId } from 'src/utils';
import { isEmpty } from 'src/validations';
import './styles.scss';
import Element from '../Element';
import View from '../View';
import { Icon } from '..';

const Input: React.FC<InputProps> = ({
  children,
  errorMessage,
  label,
  className,
  containerClassName,
  inputRef = null,
  iconName = '',
  onIconClick,
  ...props
}) => {
  const id = useRef<string>(`input-${getRandomId()}`);

  return (
    <Element id={id.current} errorMessage={errorMessage} label={label} className={containerClassName}>
      <View>
        <input
          id={id.current}
          className={cn(className, 'cmp-input', {
            'cmp-input--error': !isEmpty(errorMessage),
          })}
          ref={inputRef}
          {...props}
        />
        {iconName && <Icon name={iconName} className="cmp-input__icon" onClick={onIconClick} />}
      </View>
    </Element>
  );
};

export type InputProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLInputElement> & {
    errorMessage?: string;
    containerClassName?: string;
    inputRef?: RefObject<HTMLInputElement>;
    iconName?: string;
    onIconClick?: MouseEventHandler<HTMLElement>;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
